import { Link } from 'react-router-dom';

export const Section = ({ title, viewAllUrl, children, className = '', actions }) => {
  return (
    <div className={`flex-col ${className}`}>
      <div className="flex-row items-center justify-between m-btm-10">
        <span className="fs-15 fw-500">{title}</span>
        {actions ? (
          <div className="flex-row items-center m-right-15">{actions}</div>
        ) : (
          <Link
            to={viewAllUrl}
            className="fs-13 fw-500 m-right-15"
            style={{ color: '#007bd0', display: viewAllUrl ? 'block' : 'none' }}
          >
            View All
          </Link>
        )}
      </div>
      <div className="m-top-10 w-100-P">{children}</div>
    </div>
  );
};
